import React from 'react';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

function Copyright() {
    const urlParams = new URLSearchParams(window.location.search);
    const noCopyright = urlParams.get('nocopy');

    if(!!noCopyright) {
        return null;
    }

    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {'Copyright © '}
            <Link color="inherit" href="https://livevideo.com.ua/">
                LiveVideo
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

export default Copyright;